import React from 'react';
import type { PaymentBadgeDto } from '../../../../services/checkoutConfig/checkoutConfig.types';

interface PaymentMethodsSectionProps {
  paymentBadges: PaymentBadgeDto[];
  enabledPaymentBadgeIds: number[] | 'all';
  textColor: string;
}

export const PaymentMethodsSection: React.FC<PaymentMethodsSectionProps> = ({
  paymentBadges,
  enabledPaymentBadgeIds,
  textColor,
}) => {
  const visibleBadges =
    enabledPaymentBadgeIds === 'all'
      ? paymentBadges
      : paymentBadges.filter((badge) => enabledPaymentBadgeIds.includes(badge.id));

  if (visibleBadges.length === 0) return null;

  return (
    <div className="mb-6" style={{ color: textColor }}>
      <h3 className="text-xs font-medium mb-4" style={{ color: textColor }}>
        Formas de pagamento
      </h3>
      <div className="flex flex-wrap items-center gap-2">
        {visibleBadges.map((badge) => (
          <img
            key={badge.key}
            loading="lazy"
            alt={badge.label}
            width="29"
            height="20"
            src={badge.iconUrl}
            className="h-6 w-auto"
          />
        ))}
      </div>
    </div>
  );
};
